import React from 'react';
import {HeaderGroup} from 'react-table';

import {ChevronSmallDown, ChevronSmallUp} from '@ELib/assets/images';
import {classy} from '@ELib/utilities/HelperFunctions';

import {ETableRow} from './types';

export const THead = <Key extends string>({
  headerGroups,
  hidden,
  showColumnConfigDialog,
}: {
  headerGroups: HeaderGroup<ETableRow<Key>>[];
  hidden?: boolean;
  showColumnConfigDialog?: () => void;
}): React.ReactElement => {
  const handleRightClick = (event: React.MouseEvent) => {
    event.preventDefault();
    showColumnConfigDialog?.();
  };
  return (
    <thead style={{height: hidden ? 0 : undefined}}>
      {headerGroups.map((headerGroup) => (
        // react-table adds a key with getHeaderGroupProps
        // eslint-disable-next-line react/jsx-key
        <tr
          {...headerGroup.getHeaderGroupProps()}
          data-testid='ETable-THead-row'
          style={{
            ...(headerGroup.getHeaderGroupProps().style ?? {}),
            height: hidden ? 0 : undefined,
          }}
          onContextMenu={handleRightClick}
        >
          {headerGroup.headers.map((column) => (
            // react-table adds a key with getHeaderProps
            // eslint-disable-next-line react/jsx-key
            <th
              {...column.getHeaderProps([
                {
                  // styling that is defined by the user
                  className: column.className,
                  style: {...column.style, height: hidden ? 0 : undefined},
                },
                {
                  // styling that relies on the column type and state
                  className: classy({
                    canSort: column.canSort,
                    isSorted: column.isSorted,
                    header: column.id !== '_selection',
                    selection: column.id === '_selection',
                  }),
                },
                // typings are incomplete, but this is totally valid
                // eslint-disable-next-line @typescript-eslint/ban-ts-comment
                // @ts-ignore
                column.getSortByToggleProps({
                  // reset the title which is added by default
                  title: '',
                }),
              ])}
              data-testid={`ETable-header-${column.id}`}
            >
              <RenderIfVisible hidden={hidden}>
                {column.id === '_selection' ? (
                  column.render('Header')
                ) : (
                  <div>
                    <span>{column.render('Header')}</span>
                    {column.canSort ? (
                      column.isSortedDesc ? (
                        <ChevronSmallDown />
                      ) : (
                        <ChevronSmallUp />
                      )
                    ) : null}
                  </div>
                )}
              </RenderIfVisible>
            </th>
          ))}
        </tr>
      ))}
    </thead>
  );
};
const RenderIfVisible = ({
  hidden = false,
  children,
}: {
  hidden?: boolean;
  children: React.ReactNode;
}): React.ReactNode => (hidden ? null : children);
